module.exports = __webpack_public_path__ + "media/alert.7951dc59.wav";